import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { APIErrorResponse } from "./errors";
import { handle, getLocalISODateString, ERRORS } from "@dp/common";
import moment from "moment-timezone";
var CONTENTTYPE = "application/json";

var Payment = /*#__PURE__*/function () {
  function Payment(config, axios) {
    _classCallCheck(this, Payment);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Payment, [{
    key: "getOrdersSessionToken",
    value: function () {
      var _getOrdersSessionToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var agentID,
            correlationID,
            retryCount,
            _yield$handle,
            _yield$handle2,
            err,
            response,
            respData,
            status,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                agentID = _args.length > 0 && _args[0] !== undefined ? _args[0] : "native";
                correlationID = _args.length > 1 && _args[1] !== undefined ? _args[1] : "";
                retryCount = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
                _context.next = 5;
                return handle(this.axios.post(this.config.postfix.SESSION_TOKEN, {
                  agentID: agentID,
                  correlationID: correlationID
                }));

              case 5:
                _yield$handle = _context.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                response = _yield$handle2[1];
                respData = response === null || response === void 0 ? void 0 : response.data;
                status = respData === null || respData === void 0 ? void 0 : respData.status;

                if (!(!err && status === "SUCCESS")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", {
                  correlationID: respData.correlationID,
                  customerID: respData.customerID,
                  sessionToken: respData.sessionToken
                });

              case 15:
                return _context.abrupt("return", this.handleOrderSessionTokenError(response, err, retryCount, agentID, correlationID));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOrdersSessionToken() {
        return _getOrdersSessionToken.apply(this, arguments);
      }

      return getOrdersSessionToken;
    }()
  }, {
    key: "handleOrderSessionTokenError",
    value: function handleOrderSessionTokenError(response, err, retryCount, agentID, correlationID) {
      var respData = response === null || response === void 0 ? void 0 : response.data;
      var status = respData === null || respData === void 0 ? void 0 : respData.status;
      var responseCode = respData === null || respData === void 0 ? void 0 : respData.responseCode;

      if (responseCode === "sessionTokenLimitExceeded") {
        throw new APIErrorResponse({
          config: response.config,
          request: response.request,
          response: response
        });
      } else {
        if (retryCount > 0) {
          var newRetry = retryCount - 1;
          return this.getOrdersSessionToken(agentID, correlationID, newRetry);
        } else {
          if (err) {
            throw err;
          } else if (status !== "SUCCESS") {
            throw new APIErrorResponse({
              config: response.config,
              request: response.request,
              response: response
            });
          } else {
            return response.data;
          }
        }
      }
    }
  }, {
    key: "getMobilePaySessionToken",
    value: function () {
      var _getMobilePaySessionToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var agentID,
            correlationID,
            retryCount,
            _yield$handle3,
            _yield$handle4,
            err,
            response,
            respData,
            status,
            responseCode,
            newRetry,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                agentID = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : "native";
                correlationID = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "";
                retryCount = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 0;
                _context2.next = 5;
                return handle(this.axios.post(this.config.postfix.MOBILE_PAY_SESSION_TOKEN, {
                  agentID: agentID,
                  correlationID: correlationID
                }));

              case 5:
                _yield$handle3 = _context2.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                err = _yield$handle4[0];
                response = _yield$handle4[1];
                respData = response === null || response === void 0 ? void 0 : response.data;
                status = respData === null || respData === void 0 ? void 0 : respData.status;

                if (!(!err && status === "SUCCESS")) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", {
                  correlationID: respData.correlationID,
                  customerID: respData.customerID,
                  sessionToken: respData.sessionToken
                });

              case 15:
                responseCode = respData === null || respData === void 0 ? void 0 : respData.responseCode;

                if (!(responseCode === "sessionTokenLimitExceeded")) {
                  _context2.next = 20;
                  break;
                }

                throw {
                  config: response.config,
                  request: response.request,
                  response: response
                };

              case 20:
                if (!(retryCount > 0)) {
                  _context2.next = 25;
                  break;
                }

                newRetry = retryCount - 1;
                return _context2.abrupt("return", this.getMobilePaySessionToken(agentID, correlationID, newRetry));

              case 25:
                if (!err) {
                  _context2.next = 29;
                  break;
                }

                throw err;

              case 29:
                return _context2.abrupt("return", response.data);

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMobilePaySessionToken() {
        return _getMobilePaySessionToken.apply(this, arguments);
      }

      return getMobilePaySessionToken;
    }()
  }, {
    key: "getRSAToken",
    value: function () {
      var _getRSAToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(transactionType) {
        var correlationID,
            retryCount,
            _ref,
            _ref2,
            err,
            response,
            respData,
            status,
            responseCode,
            newRetry,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                correlationID = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : "";
                retryCount = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 0;

                if (!(retryCount <= 0)) {
                  _context3.next = 4;
                  break;
                }

                throw ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 4:
                if (!(transactionType === "ToGoRSAToken")) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 7;
                return handle(this.axios.post(this.config.postfix.RSA_TOKEN, {
                  transactionType: transactionType,
                  correlationID: correlationID
                }));

              case 7:
                _context3.t0 = _context3.sent;
                _context3.next = 27;
                break;

              case 10:
                if (!(transactionType === "MobilePayRSAToken")) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 13;
                return handle(this.axios.post(this.config.postfix.MOBILE_PAY_RSA_TOKEN, {
                  transactionType: transactionType,
                  correlationID: correlationID
                }));

              case 13:
                _context3.t1 = _context3.sent;
                _context3.next = 26;
                break;

              case 16:
                if (!(transactionType === "ProfileRSAToken")) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 19;
                return handle(this.axios.post(this.config.postfix.PROFILE_RSA_TOKEN, {
                  transactionType: "ToGoRSAToken",
                  correlationID: correlationID
                }));

              case 19:
                _context3.t2 = _context3.sent;
                _context3.next = 25;
                break;

              case 22:
                _context3.next = 24;
                return handle(this.axios.post(this.config.postfix.GIFTCARD_RSA_TOKEN, {
                  transactionType: transactionType,
                  correlationID: correlationID
                }));

              case 24:
                _context3.t2 = _context3.sent;

              case 25:
                _context3.t1 = _context3.t2;

              case 26:
                _context3.t0 = _context3.t1;

              case 27:
                _ref = _context3.t0;
                _ref2 = _slicedToArray(_ref, 2);
                err = _ref2[0];
                response = _ref2[1];
                respData = response === null || response === void 0 ? void 0 : response.data;
                status = respData === null || respData === void 0 ? void 0 : respData.status;

                if (!(!err && status === "ACTIVE")) {
                  _context3.next = 37;
                  break;
                }

                return _context3.abrupt("return", {
                  rsaData: {
                    publicKey: respData.publicKey,
                    tokenId: respData.tokenId,
                    apiKey: respData.apiKey,
                    correlationId: correlationID
                  },
                  retryRemaining: retryCount
                });

              case 37:
                responseCode = respData === null || respData === void 0 ? void 0 : respData.responseCode;

                if (!(responseCode === "rsaTokenLimitExceeded")) {
                  _context3.next = 42;
                  break;
                }

                throw new Error("Status: " + 400);

              case 42:
                if (!(retryCount > 0)) {
                  _context3.next = 47;
                  break;
                }

                newRetry = retryCount - 1;
                return _context3.abrupt("return", this.getRSAToken(transactionType, correlationID, newRetry));

              case 47:
                if (!err) {
                  _context3.next = 51;
                  break;
                }

                throw err;

              case 51:
                return _context3.abrupt("return", {
                  rsaData: response.data,
                  retryRemaining: retryCount
                });

              case 52:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getRSAToken(_x) {
        return _getRSAToken.apply(this, arguments);
      }

      return getRSAToken;
    }()
  }, {
    key: "validateToken",
    value: function () {
      var _validateToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var transactionType,
            tokenProvider,
            tokenType,
            tokenId,
            token,
            nonce,
            conceptCode,
            commonQueryParams,
            locale,
            _ref3,
            _ref4,
            error,
            response,
            respData,
            status,
            code,
            message,
            responseCode,
            isBusinessFault,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                transactionType = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : "";
                tokenProvider = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : "";
                tokenType = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : "";
                tokenId = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : "";
                token = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : "";
                nonce = _args4.length > 5 && _args4[5] !== undefined ? _args4[5] : "";
                conceptCode = this.config.getConceptCode();
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";

                if (!(transactionType === "ToGoValidateToken")) {
                  _context4.next = 15;
                  break;
                }

                _context4.next = 12;
                return handle(this.axios.post(this.config.postfix.VALIDATE_TOKEN, {
                  transactionType: transactionType,
                  tokenProvider: tokenProvider,
                  tokenType: tokenType,
                  tokenId: tokenId,
                  token: token,
                  nonce: nonce
                }));

              case 12:
                _context4.t0 = _context4.sent;
                _context4.next = 32;
                break;

              case 15:
                if (!(transactionType === "MobilePayValidateToken")) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 18;
                return handle(this.axios.post(this.config.postfix.MOBILE_PAY_VALIDATE_TOKEN, {
                  transactionType: transactionType,
                  tokenProvider: tokenProvider,
                  tokenType: tokenType,
                  tokenId: tokenId,
                  token: token,
                  nonce: nonce
                }));

              case 18:
                _context4.t1 = _context4.sent;
                _context4.next = 31;
                break;

              case 21:
                if (!(transactionType === "PROFILE")) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 24;
                return handle(this.axios.post(this.config.postfix.PROFILE_VALIDATION_TOKEN, {
                  transactionType: transactionType,
                  tokenProvider: tokenProvider,
                  tokenType: tokenType,
                  tokenId: tokenId,
                  token: token,
                  nonce: nonce
                }, {
                  params: {
                    conceptCode: conceptCode,
                    locale: locale
                  }
                }));

              case 24:
                _context4.t2 = _context4.sent;
                _context4.next = 30;
                break;

              case 27:
                _context4.next = 29;
                return handle(this.axios.post(this.config.postfix.GIFT_CARD_VALIDATE_TOKEN, {
                  transactionType: transactionType,
                  tokenProvider: tokenProvider,
                  tokenType: tokenType,
                  tokenId: tokenId,
                  token: token,
                  nonce: nonce
                }));

              case 29:
                _context4.t2 = _context4.sent;

              case 30:
                _context4.t1 = _context4.t2;

              case 31:
                _context4.t0 = _context4.t1;

              case 32:
                _ref3 = _context4.t0;
                _ref4 = _slicedToArray(_ref3, 2);
                error = _ref4[0];
                response = _ref4[1];
                respData = response === null || response === void 0 ? void 0 : response.data;
                status = respData === null || respData === void 0 ? void 0 : respData.status;

                if (!(!error && status === "success")) {
                  _context4.next = 42;
                  break;
                }

                return _context4.abrupt("return", {
                  tokenId: respData.tokenId,
                  status: respData.status
                });

              case 42:
                // Error handling
                code = respData === null || respData === void 0 ? void 0 : respData.code;
                message = respData === null || respData === void 0 ? void 0 : respData.message;
                responseCode = respData === null || respData === void 0 ? void 0 : respData.responseCode;

                if (!(responseCode === "validateTokenLimitExceeded")) {
                  _context4.next = 49;
                  break;
                }

                throw new Error("Status: " + 400);

              case 49:
                if (!(status === "error")) {
                  _context4.next = 58;
                  break;
                }

                isBusinessFault = this.isBusinessFault({
                  code: code,
                  message: message
                });

                if (!isBusinessFault) {
                  _context4.next = 55;
                  break;
                }

                throw error;

              case 55:
                throw new Error("Status: " + 400);

              case 56:
                _context4.next = 59;
                break;

              case 58:
                throw new Error("Status: " + 500);

              case 59:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function validateToken() {
        return _validateToken.apply(this, arguments);
      }

      return validateToken;
    }()
  }, {
    key: "getApplePaySessionToken",
    value: function () {
      var _getApplePaySessionToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(host, url) {
        var _yield$handle5, _yield$handle6, err, response;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return handle(this.axios.post(this.config.postfix.APPLE_PAY_SESSION_TOKEN, null, {
                  params: {
                    host: host,
                    url: url
                  }
                }));

              case 2:
                _yield$handle5 = _context5.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                err = _yield$handle6[0];
                response = _yield$handle6[1];

                if (!err) {
                  _context5.next = 10;
                  break;
                }

                throw err;

              case 10:
                return _context5.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getApplePaySessionToken(_x2, _x3) {
        return _getApplePaySessionToken.apply(this, arguments);
      }

      return getApplePaySessionToken;
    }()
  }, {
    key: "getGiftCardOrderSessionToken",
    value: function () {
      var _getGiftCardOrderSessionToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var agentID,
            correlationID,
            retryCount,
            _yield$handle7,
            _yield$handle8,
            err,
            response,
            respData,
            status,
            _args6 = arguments;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                agentID = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : "native";
                correlationID = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : "";
                retryCount = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : 0;
                _context6.next = 5;
                return handle(this.axios.post(this.config.postfix.GC_SESSION_TOKEN, {
                  agentID: agentID,
                  correlationID: correlationID
                }));

              case 5:
                _yield$handle7 = _context6.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                err = _yield$handle8[0];
                response = _yield$handle8[1];
                respData = response === null || response === void 0 ? void 0 : response.data;
                status = respData === null || respData === void 0 ? void 0 : respData.status;

                if (!(!err && status === "SUCCESS")) {
                  _context6.next = 15;
                  break;
                }

                return _context6.abrupt("return", {
                  correlationID: respData.correlationID,
                  customerID: respData.customerID,
                  sessionToken: respData.sessionToken
                });

              case 15:
                return _context6.abrupt("return", this.handleGiftCardOrderSessionTokenError(response, err, retryCount, agentID, correlationID));

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getGiftCardOrderSessionToken() {
        return _getGiftCardOrderSessionToken.apply(this, arguments);
      }

      return getGiftCardOrderSessionToken;
    }()
  }, {
    key: "handleGiftCardOrderSessionTokenError",
    value: function handleGiftCardOrderSessionTokenError(response, err, retryCount, agentID, correlationID) {
      var respData = response === null || response === void 0 ? void 0 : response.data;
      var status = respData === null || respData === void 0 ? void 0 : respData.status;
      var responseCode = respData === null || respData === void 0 ? void 0 : respData.responseCode;

      if (responseCode === "sessionTokenLimitExceeded") {
        throw new Error("Status: " + 400);
      } else {
        if (retryCount > 0) {
          var newRetry = retryCount - 1;
          return this.getGiftCardOrderSessionToken(agentID, correlationID, newRetry);
        } else {
          if (err) {
            throw err;
          } else if (status !== "SUCCESS") {
            throw new Error("Status: " + 400);
          } else {
            return response.data;
          }
        }
      }
    }
  }, {
    key: "getPaymentToken",
    value: function () {
      var _getPaymentToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(sessionToken, payload) {
        var retryCount,
            corsPrefixURL,
            commonProps,
            origin,
            headers,
            _yield$handle9,
            _yield$handle10,
            err,
            response,
            _reqError$response,
            reqError,
            responseData,
            isBusinessFault,
            newRetry,
            respData,
            code,
            message,
            _isBusinessFault,
            _newRetry,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                retryCount = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 0;
                corsPrefixURL = this.config.getPrefix().CORS_DOMAIN;
                commonProps = this.config.getCommonProps();
                origin = commonProps.origin;
                headers = {
                  "Content-Type": CONTENTTYPE,
                  "X-App-UserId": sessionToken.customerID,
                  "X-Merchant-Id": this.config.getGiftCardType(),
                  "X-Message-Sending-PartnerId": "DARDEN_MOBILE",
                  "X-Request-ID": sessionToken.correlationID,
                  "X-User-SessionToken": sessionToken.sessionToken
                };

                if (origin) {
                  headers["Origin"] = origin;
                }

                _context7.next = 8;
                return handle(this.axios.post(corsPrefixURL + this.config.postfix.CORS_URL, payload, {
                  headers: headers,
                  params: _objectSpread(_objectSpread({}, this.config.getCommonQueryParams()), {}, {
                    noTag: true
                  })
                }));

              case 8:
                _yield$handle9 = _context7.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 2);
                err = _yield$handle10[0];
                response = _yield$handle10[1];

                if (!err) {
                  _context7.next = 28;
                  break;
                }

                reqError = err;
                responseData = reqError === null || reqError === void 0 ? void 0 : (_reqError$response = reqError.response) === null || _reqError$response === void 0 ? void 0 : _reqError$response.data;
                isBusinessFault = this.isBusinessFault(responseData);

                if (!isBusinessFault) {
                  _context7.next = 20;
                  break;
                }

                throw err;

              case 20:
                if (!(retryCount > 0)) {
                  _context7.next = 25;
                  break;
                }

                newRetry = retryCount - 1;
                return _context7.abrupt("return", this.getPaymentToken(sessionToken, payload, newRetry));

              case 25:
                throw err;

              case 26:
                _context7.next = 46;
                break;

              case 28:
                respData = response.data;
                code = respData === null || respData === void 0 ? void 0 : respData.code;
                message = respData === null || respData === void 0 ? void 0 : respData.message;

                if (!(!respData || code || message)) {
                  _context7.next = 45;
                  break;
                }

                _isBusinessFault = this.isBusinessFault({
                  code: code,
                  message: message
                });

                if (!_isBusinessFault) {
                  _context7.next = 37;
                  break;
                }

                throw respData;

              case 37:
                if (!(retryCount > 0)) {
                  _context7.next = 42;
                  break;
                }

                _newRetry = retryCount - 1;
                return _context7.abrupt("return", this.getPaymentToken(sessionToken, payload, _newRetry));

              case 42:
                return _context7.abrupt("return", respData);

              case 43:
                _context7.next = 46;
                break;

              case 45:
                return _context7.abrupt("return", respData);

              case 46:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getPaymentToken(_x4, _x5) {
        return _getPaymentToken.apply(this, arguments);
      }

      return getPaymentToken;
    }()
  }, {
    key: "getPaymentTokenRSA",
    value: function () {
      var _getPaymentTokenRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(rsaToken, payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                response = this.makeCORSRequest(rsaToken, payload);
                _context8.next = 3;
                return response;

              case 3:
                _context8.t0 = _context8.sent.paymentToken;
                _context8.next = 6;
                return response;

              case 6:
                _context8.t1 = _context8.sent.providerToken;
                _context8.next = 9;
                return response;

              case 9:
                _context8.t2 = _context8.sent.cardType;
                return _context8.abrupt("return", {
                  paymentToken: _context8.t0,
                  provider: _context8.t1,
                  cardType: _context8.t2
                });

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getPaymentTokenRSA(_x6, _x7) {
        return _getPaymentTokenRSA.apply(this, arguments);
      }

      return getPaymentTokenRSA;
    }()
  }, {
    key: "getPayPalTokenRSA",
    value: function () {
      var _getPayPalTokenRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(rsaToken, payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                response = this.makePayPalCORSRequest(rsaToken, payload);
                _context9.next = 3;
                return response;

              case 3:
                _context9.t0 = _context9.sent.expiryMonth;
                _context9.next = 6;
                return response;

              case 6:
                _context9.t1 = _context9.sent.expiryYear;
                _context9.next = 9;
                return response;

              case 9:
                _context9.t2 = _context9.sent.tokenId;
                return _context9.abrupt("return", {
                  authStatus: "success",
                  expiryMonth: _context9.t0,
                  fdAuthorizationId: "",
                  sHostExtraInfo: "",
                  expiryYear: _context9.t1,
                  paypalToken: _context9.t2
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getPayPalTokenRSA(_x8, _x9) {
        return _getPayPalTokenRSA.apply(this, arguments);
      }

      return getPayPalTokenRSA;
    }()
  }, {
    key: "getPaymentNonceRSA",
    value: function () {
      var _getPaymentNonceRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(rsaToken, payload) {
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                response = this.makeCORSRequest(rsaToken, payload);
                _context10.next = 3;
                return response;

              case 3:
                _context10.t0 = _context10.sent.paymentNonce;
                _context10.next = 6;
                return response;

              case 6:
                _context10.t1 = _context10.sent.providerNonce;
                return _context10.abrupt("return", {
                  paymentNonce: _context10.t0,
                  provider: _context10.t1
                });

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getPaymentNonceRSA(_x10, _x11) {
        return _getPaymentNonceRSA.apply(this, arguments);
      }

      return getPaymentNonceRSA;
    }()
  }, {
    key: "makeCORSRequest",
    value: function () {
      var _makeCORSRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(rsaToken, payload) {
        var _respData$credit, _respData$credit$toke, _respData$credit2, _respData$credit2$tok, _respData$credit3, _respData$token, _respData$token2;

        var response, respData;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.corsRequest(rsaToken, payload);

              case 2:
                response = _context11.sent;
                respData = response.data;
                return _context11.abrupt("return", {
                  paymentToken: respData === null || respData === void 0 ? void 0 : (_respData$credit = respData.credit) === null || _respData$credit === void 0 ? void 0 : (_respData$credit$toke = _respData$credit.token) === null || _respData$credit$toke === void 0 ? void 0 : _respData$credit$toke.tokenId,
                  providerToken: respData === null || respData === void 0 ? void 0 : (_respData$credit2 = respData.credit) === null || _respData$credit2 === void 0 ? void 0 : (_respData$credit2$tok = _respData$credit2.token) === null || _respData$credit2$tok === void 0 ? void 0 : _respData$credit2$tok.tokenProvider,
                  cardType: respData === null || respData === void 0 ? void 0 : (_respData$credit3 = respData.credit) === null || _respData$credit3 === void 0 ? void 0 : _respData$credit3.cardType,
                  paymentNonce: respData === null || respData === void 0 ? void 0 : (_respData$token = respData.token) === null || _respData$token === void 0 ? void 0 : _respData$token.tokenId,
                  providerNonce: respData === null || respData === void 0 ? void 0 : (_respData$token2 = respData.token) === null || _respData$token2 === void 0 ? void 0 : _respData$token2.tokenProvider
                });

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function makeCORSRequest(_x12, _x13) {
        return _makeCORSRequest.apply(this, arguments);
      }

      return makeCORSRequest;
    }()
  }, {
    key: "makePayPalCORSRequest",
    value: function () {
      var _makePayPalCORSRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(rsaToken, payload) {
        var _respData$paypal, _respData$paypal$cred, _respData$paypal2, _respData$paypal2$cre, _respData$paypal3, _respData$paypal3$cre, _respData$paypal3$cre2, _respData$paypal4, _respData$paypal4$cre, _respData$paypal4$cre2, _respData$paypal5, _respData$paypal5$cre, _respData$paypal5$cre2, _respData$paypal6, _respData$paypal6$cre, _respData$paypal6$cre2;

        var response, respData;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.corsRequest(rsaToken, payload);

              case 2:
                response = _context12.sent;
                respData = response.data;
                return _context12.abrupt("return", {
                  type: respData === null || respData === void 0 ? void 0 : respData.type,
                  alias: respData === null || respData === void 0 ? void 0 : (_respData$paypal = respData.paypal) === null || _respData$paypal === void 0 ? void 0 : (_respData$paypal$cred = _respData$paypal.credit) === null || _respData$paypal$cred === void 0 ? void 0 : _respData$paypal$cred.alias,
                  cardType: respData === null || respData === void 0 ? void 0 : (_respData$paypal2 = respData.paypal) === null || _respData$paypal2 === void 0 ? void 0 : (_respData$paypal2$cre = _respData$paypal2.credit) === null || _respData$paypal2$cre === void 0 ? void 0 : _respData$paypal2$cre.cardType,
                  expiryMonth: respData === null || respData === void 0 ? void 0 : (_respData$paypal3 = respData.paypal) === null || _respData$paypal3 === void 0 ? void 0 : (_respData$paypal3$cre = _respData$paypal3.credit) === null || _respData$paypal3$cre === void 0 ? void 0 : (_respData$paypal3$cre2 = _respData$paypal3$cre.expiryDate) === null || _respData$paypal3$cre2 === void 0 ? void 0 : _respData$paypal3$cre2.month,
                  expiryYear: respData === null || respData === void 0 ? void 0 : (_respData$paypal4 = respData.paypal) === null || _respData$paypal4 === void 0 ? void 0 : (_respData$paypal4$cre = _respData$paypal4.credit) === null || _respData$paypal4$cre === void 0 ? void 0 : (_respData$paypal4$cre2 = _respData$paypal4$cre.expiryDate) === null || _respData$paypal4$cre2 === void 0 ? void 0 : _respData$paypal4$cre2.year,
                  tokenProvider: respData === null || respData === void 0 ? void 0 : (_respData$paypal5 = respData.paypal) === null || _respData$paypal5 === void 0 ? void 0 : (_respData$paypal5$cre = _respData$paypal5.credit) === null || _respData$paypal5$cre === void 0 ? void 0 : (_respData$paypal5$cre2 = _respData$paypal5$cre.token) === null || _respData$paypal5$cre2 === void 0 ? void 0 : _respData$paypal5$cre2.tokenProvider,
                  tokenId: respData === null || respData === void 0 ? void 0 : (_respData$paypal6 = respData.paypal) === null || _respData$paypal6 === void 0 ? void 0 : (_respData$paypal6$cre = _respData$paypal6.credit) === null || _respData$paypal6$cre === void 0 ? void 0 : (_respData$paypal6$cre2 = _respData$paypal6$cre.token) === null || _respData$paypal6$cre2 === void 0 ? void 0 : _respData$paypal6$cre2.tokenId
                });

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function makePayPalCORSRequest(_x14, _x15) {
        return _makePayPalCORSRequest.apply(this, arguments);
      }

      return makePayPalCORSRequest;
    }()
  }, {
    key: "corsRequest",
    value: function () {
      var _corsRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(rsaToken, payload) {
        var headers, _yield$handle11, _yield$handle12, error, response, respData;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                headers = {
                  "Content-Type": CONTENTTYPE,
                  Authorization: "Bearer " + rsaToken.tokenId,
                  "Api-Key": rsaToken.apiKey,
                  Timestamp: moment().toDate().getTime(),
                  "Client-Request-Id": rsaToken.correlationId,
                  Origin: this.config.getDefaultAPIPrefix()
                };
                _context13.next = 3;
                return handle(this.axios.post(this.config.getPrefix().CORS_DOMAIN_RSA + this.config.postfix.CORS_URL_RSA, payload, {
                  headers: headers,
                  params: _objectSpread(_objectSpread({}, this.config.getCommonQueryParams()), {}, {
                    noTag: true
                  })
                }));

              case 3:
                _yield$handle11 = _context13.sent;
                _yield$handle12 = _slicedToArray(_yield$handle11, 2);
                error = _yield$handle12[0];
                response = _yield$handle12[1];
                respData = response.data;

                if (!(error || !respData)) {
                  _context13.next = 10;
                  break;
                }

                throw error;

              case 10:
                return _context13.abrupt("return", response);

              case 11:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function corsRequest(_x16, _x17) {
        return _corsRequest.apply(this, arguments);
      }

      return corsRequest;
    }()
  }, {
    key: "isBusinessFault",
    value: function isBusinessFault(responseData) {
      var businessFaults = ["CARD_VALIDATION_FAILED", "CARD_TYPE_NOT_SUPPORTED"];

      if (responseData) {
        return businessFaults.reduce(function (res, fault) {
          if (res) {
            return true;
          } else {
            res = fault === responseData.message;
          }

          return res;
        }, false);
      } else {
        return true;
      }
    }
  }, {
    key: "tokenizeCreditCard",
    value: function () {
      var _tokenizeCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(cardAccount) {
        var tokenType,
            retryCount,
            sessionToken,
            payload,
            _args14 = arguments;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                tokenType = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : "LONGTERM";
                retryCount = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : 0;
                _context14.next = 4;
                return this.getOrdersSessionToken("native", "", retryCount);

              case 4:
                sessionToken = _context14.sent;
                payload = {
                  account: cardAccount,
                  paymentTokenType: tokenType
                };
                return _context14.abrupt("return", this.getPaymentToken(sessionToken, payload, retryCount));

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function tokenizeCreditCard(_x18) {
        return _tokenizeCreditCard.apply(this, arguments);
      }

      return tokenizeCreditCard;
    }()
  }, {
    key: "logCCTokenizationFailure",
    value: function () {
      var _logCCTokenizationFailure = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(request) {
        var queryParams, payload;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                queryParams = {
                  action: "ERROR"
                };
                payload = _objectSpread(_objectSpread({}, request), {}, {
                  customerLocalDate: getLocalISODateString(moment().toDate())
                });
                _context15.next = 4;
                return this.axios.post(this.config.postfix.TOKENIZATION_FAILURE, payload, {
                  params: queryParams
                });

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function logCCTokenizationFailure(_x19) {
        return _logCCTokenizationFailure.apply(this, arguments);
      }

      return logCCTokenizationFailure;
    }()
  }, {
    key: "tokenizePayPal",
    value: function () {
      var _tokenizePayPal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payerId, payLoadNonce, deviceData) {
        var channel,
            response,
            _args16 = arguments;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                channel = _args16.length > 3 && _args16[3] !== undefined ? _args16[3] : "desktop";
                _context16.next = 3;
                return this.axios.post(this.config.postfix.TOKENIZE_PAYPAL, {
                  payerId: payerId,
                  payLoadNonce: payLoadNonce,
                  deviceData: deviceData,
                  transactionType: "PAYPAL_TOGO",
                  channel: channel
                });

              case 3:
                response = _context16.sent;
                return _context16.abrupt("return", response.data);

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function tokenizePayPal(_x20, _x21, _x22) {
        return _tokenizePayPal.apply(this, arguments);
      }

      return tokenizePayPal;
    }()
  }, {
    key: "getGiftCardBalance",
    value: function () {
      var _getGiftCardBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(giftCardNumber, gRecaptchaResponse, gcCheckBalFromCheckout) {
        var _response$data;

        var gcNumber, response;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                gcNumber = giftCardNumber ? giftCardNumber.split("-").join("") : giftCardNumber;
                _context17.next = 3;
                return this.axios.post(this.config.postfix.CHECK_GC_BALANCE, {
                  giftCardNumber: gcNumber,
                  gRecaptchaResponse: gRecaptchaResponse,
                  giftCardCheckBalanceApi: true,
                  gcCheckBalFromCheckout: gcCheckBalFromCheckout
                }, {
                  headers: {
                    Accept: CONTENTTYPE
                  }
                });

              case 3:
                response = _context17.sent;
                return _context17.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.successResponse);

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getGiftCardBalance(_x23, _x24, _x25) {
        return _getGiftCardBalance.apply(this, arguments);
      }

      return getGiftCardBalance;
    }()
  }, {
    key: "deleteGiftCard",
    value: function () {
      var _deleteGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(userId, giftCardId, giftCardNumber) {
        var _response$data2, commonQueryParams, locale, response;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context18.next = 5;
                return this.axios.post(this.config.postfix.REMOVE_GIFT_CARD, {
                  userId: userId,
                  giftCardId: giftCardId,
                  giftCardNumber: giftCardNumber,
                  locale: locale
                });

              case 5:
                response = _context18.sent;
                return _context18.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.successResponse);

              case 9:
                _context18.prev = 9;
                _context18.t0 = _context18["catch"](0);
                return _context18.abrupt("return", _context18.t0);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 9]]);
      }));

      function deleteGiftCard(_x26, _x27, _x28) {
        return _deleteGiftCard.apply(this, arguments);
      }

      return deleteGiftCard;
    }()
  }]);

  return Payment;
}();

export { Payment as default };